// PPS CRM - Commissions Module
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

interface Commission {
  id: string;
  status: 'PENDING' | 'AVAILABLE' | 'CASHED_OUT';
  totalEarned: string;
  transactionDate: string;
  agent?: { agentCode?: string; fullLegalName?: string };
  transaction?: { client?: { fullLegalName?: string } };
}

export default function Commissions() {
  const [commissions, setCommissions] = useState<Commission[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCommissions();
  }, []);

  const fetchCommissions = async () => {
    try {
      const response = await api.get('/api/commissions');
      setCommissions(response.data);
    } catch (error) {
      console.error('Error fetching commissions:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Commissions</h2>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="p-8 text-center">Loading...</div>
        ) : commissions.length === 0 ? (
          <div className="p-8 text-center text-dark-gray">No commissions found</div>
        ) : (
          <table className="w-full">
            <thead className="bg-light-gray">
              <tr>
                <th className="px-4 py-3 text-left">Client</th>
                <th className="px-4 py-3 text-left">Agent</th>
                <th className="px-4 py-3 text-left">Amount</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {commissions.map((c) => (
                <tr key={c.id} className="border-b border-light-gray hover:bg-light-gray">
                  <td className="px-4 py-3">{c.transaction?.client?.fullLegalName || '-'}</td>
                  <td className="px-4 py-3">{c.agent?.agentCode || '-'}</td>
                  <td className="px-4 py-3">${Number(c.totalEarned).toFixed(2)}</td>
                  <td className="px-4 py-3">{c.status}</td>
                  <td className="px-4 py-3">{new Date(c.transactionDate).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
